import profile from '../other/profile';
import additionalDocument from '../shared/additionalDocument';
import address from '../shared/address';
import bill from '../shared/bill';
import contact from '../shared/contact';
import discount from '../shared/discount';
import document from '../shared/document';
import notes from '../shared/notes';
import payment from '../shared/payment';
import paymentDocument from '../shared/paymentDocument';
import rentalObject from '../shared/rentalObject';

const mietendeckel = `
    accessibleElevator
    additionalDocuments {
        ${additionalDocument}
    }
    agreement {
        ${document}
    }
    auskunftsbegehren {
        ${document}
    }
    bankAccount {
        iban
        id
        name
    }
    bankAccountId
    billingAddress {
        ${address}
    }
    billingAddressId
    billings {
        ${bill}
    }
    billReportBasePrice
    caseHeros
    caseId
    created
    debtorLawyer {
        ${contact}
        caseNumber
    }
    detatchedHouse
    discountId
    discount {
        ${discount}
    }
    energyConsumption
    finished
    fittedKitchen
    highQualityFlooring
    highQualitySanitaryWare
    id
    illegalRentIncrease
    illegalRentIncreasePerMonth
    incomingPayments {
        ${payment}
    }
    inputCompleted
    inputOverview {
        ${document}
    }
    lastMail
    lastStatusChange
    monitions {
        ${paymentDocument}
    }
    nextDeadline
    ${notes}
    originalRent
    outgoingPayments {
        ${payment}
    }
    overRentCap
    overRentCapPerMonth
    ownerSub
    partitionKey
    path
    productType
    profile {
        ${profile}
    }
    referrer {
        id
        referringPartner
    }
    rentalObject {
        ${rentalObject}
    }
    rentalObjectId
    report {
        ${document}
    }
    reportBasePrice
    requestsPayments {
        ${paymentDocument}
    }
    resubmissions {
        author
        message
        remember
    }
    sales
    signatures {
        id
        signature
        tenantId
    }
    status
    type
    warning
    yearOfConstruction
`;

export default mietendeckel;
